import React, { useEffect, useState } from 'react';
import AppRoutes from './routes/Routes';
import { UserContextProvider } from './context/UserContext';
import { NotificationProvider } from './context/NotificationContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from './theme';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { isSupported } from './config/firebase-config';

// Only import NotificationDebug in development
const NotificationDebug = process.env.NODE_ENV === 'development'
  ? require('./components/NotificationDebug').default
  : null;

const App = () => {
  const [isFCMSupported, setIsFCMSupported] = useState(false);

  useEffect(() => {
    isSupported().then((supported) => {
      if (!supported) {
        return;
      }

      setIsFCMSupported(true);

      if ('serviceWorker' in navigator) {
        // ✅ Check if service worker already exists
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          const existingSW = registrations.find(reg =>
            reg.active?.scriptURL?.includes('firebase-messaging-sw.js')
          );

          if (existingSW) {
            return;
          }

          // Register new service worker
          navigator.serviceWorker
            .register('/firebase-messaging-sw.js')
            .then((reg) => {
              // Service Worker registered
            })
            .catch((err) => {
              // SW registration failed
            });
        });
      }
    });
  }, []);

  const AppTree = (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        theme="colored" // ya "light" agar aapko light chahiye
        pauseOnHover
      />
    </ThemeProvider>
  );

  const AppTreeWithNotificationDebug = (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
      {/* {NotificationDebug && <NotificationDebug />} */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        theme="colored" // ya "light" agar aapko light chahiye
        pauseOnHover
      />
    </ThemeProvider>
  );

  return (
    <UserContextProvider>
      {isFCMSupported ? (
        <NotificationProvider>{AppTreeWithNotificationDebug}</NotificationProvider>
      ) : (
        AppTree
      )}
    </UserContextProvider>
  );
};

export default App;
